var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustracaoSucesso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 103.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Gradiente_sem_nome_3-3);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        stroke-width: 0px;\n      }\n\n      .cls-14 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#Gradiente_sem_nome_3-2);\n      }\n\n      .cls-3 {\n        fill: #fdf5e6;\n      }\n\n      .cls-4, .cls-15 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #071d41;\n      }\n\n      .cls-6 {\n        fill: url(#Gradiente_sem_nome_6);\n      }\n\n      .cls-7 {\n        fill: #f08080;\n      }\n\n      .cls-8 {\n        fill: #00a91c;\n      }\n\n      .cls-9 {\n        fill: url(#Gradiente_sem_nome_4);\n      }\n\n      .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-11 {\n        fill: url(#Gradiente_sem_nome_3);\n      }\n\n      .cls-12 {\n        fill: url(#Gradiente_sem_nome_6-2);\n      }\n\n      .cls-13 {\n        fill: #1351b4;\n      }\n\n      .cls-15 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 7px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    "data-name": "Gradiente sem nome 3",
    x1: 7567.16,
    y1: 121.19,
    x2: 7556.49,
    y2: 103.31,
    gradientTransform: "translate(7581.66 161.1) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5992ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155bcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    "data-name": "Gradiente sem nome 3",
    x1: 7541.81,
    y1: 159.35,
    x2: 7497.2,
    y2: 61.76,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-3",
    "data-name": "Gradiente sem nome 3",
    x1: 6155.48,
    y1: 721.7,
    x2: 6110.09,
    y2: 622.38,
    gradientTransform: "translate(3630.52 -4986.78) rotate(118.72)",
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    x1: 7428.49,
    y1: 108.48,
    x2: 7574.78,
    y2: 108.48,
    gradientTransform: "translate(7581.66 161.1) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d4eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    "data-name": "Gradiente sem nome 6",
    x1: 69.9,
    y1: 67.1,
    x2: 93.17,
    y2: 67.1,
    gradientTransform: "translate(0 161.1) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f174d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e2bb1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6-2",
    "data-name": "Gradiente sem nome 6",
    x1: 40.5,
    y1: 78.03,
    x2: 122.57,
    y2: 78.03,
    xlinkHref: "#Gradiente_sem_nome_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor",
    className: "cls-11",
    d: "M16.26,38.62c-6.81,3.64-9.65,13.14-4.46,22.42,1.3,2.33,3.3,3.87,5.27,3.45,4.58-.98,6.25-10.55,10.63-12.38,1.06-.44,2.2-.38,3.21-1.07,5.51-3.78-2.29-19.03-14.64-12.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-2",
    className: "cls-2",
    d: "M31.33,66.34c12.91,27.26,37.44,40.6,54.71,32.43,17.27-8.18,20.74-34.79,7.84-62.05C80.98,9.48,56.51-5.99,39.24,2.19c-17.27,8.18-20.81,36.9-7.91,64.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3",
    className: "cls-1",
    d: "M88.37,103.41c30.1,1.78,59.22-13.04,60.35-32.12,1.13-19.08-22.36-35.99-52.46-37.77-30.1-1.78-55.42,12.24-56.55,31.32-1.13,19.08,18.56,36.79,48.66,38.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-4",
    className: "cls-9",
    d: "M135.63,8.6C124.56,2.54,111.33.5,98.94,2.94c-12.39,2.44-23.85,9.34-31.8,19.15-5.31,6.55-9.22,14.45-16,19.47-6.81,5.04-15.54,6.45-23.7,8.74-15.56,4.37-24.55,15.75-18.83,27.95,6.39,13.64,21.55,14.82,31.3,17.46,11.1,3.01,24.83,9.88,40.34,6.83,12.8-2.51,23.12-15.83,34.23-22.65,13.31-8.18,23.89-9.93,32.53-21.91,12.25-16.97,5.1-40.37-11.36-49.38h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "padroes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M151.69,62.14c-.28-.2-.34-.59-.14-.87.48-.66.94-1.35,1.38-2.04.18-.29.57-.38.86-.2s.38.57.2.86c-.45.71-.92,1.42-1.42,2.1-.12.17-.31.26-.51.26-.13,0-.25-.04-.36-.12h0ZM155.16,56.59c-.31-.15-.43-.53-.28-.84.36-.74.71-1.49,1.02-2.24.13-.32.5-.47.82-.34.32.13.47.5.34.82-.32.77-.67,1.55-1.05,2.31-.11.22-.33.35-.56.35-.09,0-.19-.02-.28-.06ZM157.65,50.54c-.33-.1-.52-.45-.42-.78.23-.78.44-1.58.62-2.37.08-.33.41-.55.75-.47.33.08.55.41.47.75-.19.82-.4,1.65-.64,2.45-.08.27-.33.45-.6.45-.06,0-.12,0-.18-.03ZM159.08,44.15c-.34-.04-.59-.35-.55-.69.1-.81.17-1.63.21-2.45.02-.34.32-.61.66-.59.34.02.61.31.59.66-.05.84-.12,1.69-.22,2.52-.04.32-.31.55-.62.55-.03,0-.05,0-.08,0h0ZM158.75,37.02c-.04-.82-.1-1.64-.2-2.45-.04-.34.21-.65.55-.69.34-.04.65.21.69.55.09.84.16,1.68.2,2.52.02.34-.25.64-.59.65h-.03c-.33,0-.61-.26-.62-.59h0ZM157.93,30.62c-.05-.21-.09-.43-.14-.64-.13-.59-.28-1.17-.43-1.75-.09-.33.1-.68.44-.76s.68.11.76.44c.16.59.31,1.2.45,1.8.05.22.1.44.14.66.07.34-.15.67-.48.74-.04,0-.09.01-.13.01-.29,0-.55-.2-.61-.5ZM156.12,24.43c-.29-.76-.6-1.53-.94-2.27-.14-.31,0-.69.31-.82s.69,0,.82.31c.34.76.67,1.55.97,2.34.12.32-.04.68-.36.8-.07.03-.15.04-.22.04-.25,0-.49-.15-.59-.41h0ZM153.38,18.59c-.41-.71-.84-1.41-1.28-2.1-.19-.29-.11-.68.18-.87s.68-.11.87.18c.46.71.9,1.43,1.32,2.16.17.3.07.68-.23.85-.1.05-.2.08-.31.08-.22,0-.43-.11-.54-.31h0ZM149.75,13.26c-.51-.64-1.05-1.26-1.6-1.86-.23-.25-.21-.65.04-.88.25-.23.65-.21.88.04.57.62,1.12,1.27,1.65,1.92.22.27.18.66-.09.88-.12.09-.25.14-.39.14-.18,0-.36-.08-.48-.23h0ZM145.31,8.6c-.61-.54-1.25-1.07-1.89-1.57-.27-.21-.32-.61-.11-.88.21-.27.61-.32.88-.11.66.52,1.32,1.06,1.95,1.62.26.23.28.62.05.88-.12.14-.29.21-.47.21-.15,0-.3-.05-.41-.16h0ZM140.15,4.74c-.69-.43-1.41-.84-2.12-1.23-.31-.16-.42-.54-.25-.84s.54-.42.84-.25c.74.4,1.48.82,2.19,1.27.29.18.38.57.2.86-.12.19-.32.29-.53.29-.11,0-.23-.03-.33-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M26.57,97.87c-.87-.17-1.68-.35-2.46-.53-.33-.08-.54-.41-.46-.75.08-.33.42-.54.75-.46.77.18,1.56.35,2.42.52.34.07.56.4.49.73-.06.3-.32.5-.61.5-.04,0-.08,0-.12-.01h0ZM20.15,96.24c-.82-.27-1.63-.55-2.39-.86-.32-.13-.48-.49-.35-.81s.49-.48.81-.35c.74.29,1.52.57,2.31.83.33.1.51.46.4.79-.08.26-.33.43-.59.43-.06,0-.13,0-.19-.03h0ZM14.02,93.63c-.75-.41-1.49-.86-2.18-1.32-.29-.19-.36-.58-.17-.87.19-.29.58-.36.87-.17.66.44,1.36.87,2.09,1.27.3.17.41.55.25.85-.11.21-.33.32-.55.32-.1,0-.2-.03-.3-.08ZM8.58,89.74c-.62-.58-1.22-1.19-1.79-1.83-.23-.26-.2-.65.05-.88.26-.23.65-.2.88.05.53.61,1.11,1.19,1.7,1.74.25.23.27.63.03.88-.12.13-.29.2-.46.2-.15,0-.31-.05-.42-.17h0ZM4.29,84.61c-.45-.7-.88-1.45-1.28-2.2-.16-.31-.04-.68.26-.84.31-.16.68-.04.84.26.38.73.79,1.43,1.22,2.11.19.29.1.68-.19.86-.1.07-.22.1-.34.1-.2,0-.41-.1-.53-.29ZM1.35,78.61c-.28-.81-.53-1.64-.72-2.46-.08-.33.13-.67.46-.75s.67.13.75.46c.18.78.41,1.56.69,2.33.11.33-.06.68-.38.79-.07.03-.14.03-.2.03-.26,0-.5-.16-.59-.42h0ZM.03,72.03c-.02-.39-.03-.79-.03-1.17,0-.47.01-.94.04-1.39.02-.34.32-.61.66-.59.34.02.61.32.59.66-.03.43-.04.87-.04,1.31,0,.37,0,.74.03,1.11.02.34-.25.64-.59.66h-.03c-.33,0-.61-.26-.62-.59h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-5",
    className: "cls-6",
    d: "M93.17,103.27h-23.27l4.65-18.55h13.96l4.65,18.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    className: "cls-4",
    d: "M90.13,91.17h-17.21l1.62-6.46h13.96l1.62,6.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-6",
    className: "cls-3",
    d: "M122.57,32.71v52.46c0,1.71-1.38,3.09-3.08,3.1H43.57c-1.7,0-3.08-1.39-3.08-3.09v-52.46c0-1.71,1.38-3.09,3.08-3.09h75.92c1.7,0,3.08,1.39,3.08,3.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-7",
    className: "cls-7",
    d: "M122.57,39.56v-6.85c0-1.71-1.38-3.09-3.08-3.09H43.57c-1.7,0-3.08,1.38-3.08,3.09h0v6.85h82.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-8",
    className: "cls-12",
    d: "M40.5,77.87v7.3c0,1.71,1.38,3.09,3.08,3.09h75.92c1.7,0,3.08-1.38,3.08-3.09h0v-7.3H40.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-9",
    className: "cls-4",
    d: "M107.69,77.97h-51.91v-43.49c0-1.5,1.21-2.72,2.7-2.72h46.5c1.49,0,2.7,1.22,2.7,2.72v43.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.27,70.8h3.22c.75,0,1.35-.61,1.35-1.36s-.61-1.36-1.35-1.36h-3.22c-.75,0-1.35.61-1.35,1.36s.61,1.36,1.35,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.43,70.8h12.4c.75,0,1.35-.61,1.35-1.36s-.61-1.36-1.35-1.36h-12.4c-.75,0-1.35.61-1.35,1.36s.61,1.36,1.35,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.78,70.8h11.42c.75,0,1.35-.61,1.35-1.36s-.61-1.36-1.35-1.36h-11.42c-.75,0-1.35.61-1.35,1.36s.61,1.36,1.35,1.36Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M81.53,21.94c-11.24,0-20.36,9.12-20.36,20.36s9.12,20.36,20.36,20.36,20.36-9.12,20.36-20.36-9.12-20.36-20.36-20.36h0ZM90.52,38.57l-10.18,10.18c-.75.75-1.96.75-2.7,0l-5.09-5.09c-.75-.75-.75-1.96,0-2.7s1.96-.75,2.7,0l3.74,3.74,8.83-8.84c.75-.75,1.96-.75,2.7,0,.74.74.75,1.96,0,2.7h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 90.17,
    y1: 36.84,
    x2: 78.88,
    y2: 47.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 72.21,
    y1: 42.48,
    x2: 78.17,
    y2: 48.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    "data-name": "Caminho 574",
    className: "cls-10",
    d: "M48.73,35.63c-.56,0-1.02-.46-1.02-1.02h0v-.03c0-.56.46-1.02,1.02-1.02.56,0,1.02.46,1.02,1.02v.03c0,.56-.46,1.02-1.02,1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    "data-name": "Caminho 575",
    className: "cls-10",
    d: "M52.69,35.63c-.56,0-1.02-.46-1.02-1.02h0v-.03c0-.56.46-1.02,1.02-1.02.56,0,1.02.46,1.02,1.02v.03c0,.56-.46,1.02-1.02,1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    "data-name": "Caminho 576",
    className: "cls-10",
    d: "M56.64,35.63c-.56,0-1.02-.46-1.02-1.02h0v-.03c0-.56.46-1.02,1.02-1.02s1.02.46,1.02,1.02v.03c0,.56-.46,1.02-1.02,1.02h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracaoSucesso);
export default __webpack_public_path__ + "static/media/ilustracao-sucesso.b59bdbedf0267cef3996502ad3b22b50.svg";
export { ForwardRef as ReactComponent };